import { EStorageType } from 'reactApp/modules/storage/storage.types';

export const isEditingStorage = (storage: EStorageType) =>
    [EStorageType.myofficeAttaches, EStorageType.myoffice, EStorageType.r7, EStorageType.r7wopi].includes(storage);

export const isEditingAttach = (storage: EStorageType) => storage === EStorageType.myofficeAttaches;
